import { render, staticRenderFns } from "./content3.vue?vue&type=template&id=178f71b9&scoped=true&"
import script from "./content3.vue?vue&type=script&lang=js&"
export * from "./content3.vue?vue&type=script&lang=js&"
import style0 from "./content3.vue?vue&type=style&index=0&id=178f71b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178f71b9",
  null
  
)

export default component.exports